import { z } from 'zod';

export const ADMIN_ROLE_NAMES = ['booking', 'chat_viewer', 'marketing'] as const;

export const AdminRoleSchema = z.enum(ADMIN_ROLE_NAMES);
export type AdminRole = z.infer<typeof AdminRoleSchema>;

export interface AdminRoleDefinition {
  name: AdminRole;
  label: string;
  description: string;
}

export const ADMIN_ROLES = [
  {
    name: 'booking',
    label: 'Booking',
    description: 'Access to booking management.',
  },
  {
    name: 'chat_viewer',
    label: 'Chat Viewer',
    description: "Access to inspect travelers' chats.",
  },
  {
    name: 'marketing',
    label: 'Marketing',
    description: 'Access to waitlist, invite codes, and dashboard.',
  },
] as const satisfies readonly AdminRoleDefinition[];

export const AdminRoleClaimsSchema = z.looseObject({
  booking: z.boolean().optional(),
  chat_viewer: z.boolean().optional(),
  marketing: z.boolean().optional(),
});
export type AdminRoleClaims = z.infer<typeof AdminRoleClaimsSchema>;
